// Committees that have the Device Library tab. The API decides access
// (librarySettings.enabled); this list only controls where the tab shows.
export const ELECTRICAL_GROUP_ID = '5e44050f4e6ed37ab467d0f2';
export const LIBRARY_GROUP_IDS = [ELECTRICAL_GROUP_ID];

// Placeholder wording (open decision D6); replace before public launch.
export const LIBRARY_DISCLAIMER =
    'Reference content provided by SDSIC members. Verify against manufacturer documentation before use in design.';

export const FILE_KIND_LABELS = {
    footprint_dwg: 'Footprint DWG',
    preview_image: 'Preview image',
    footprint_pdf: 'Footprint PDF',
    schematic_dwg: 'Schematic DWG',
    other: 'Other'
};

export const BRAND = { primary: '#003E7E', action: '#FF6600', actionHover: '#e55a00' };

// Same rule as the API's helpers/libraryNaming.js buildCode, for the live
// preview in the form. The server always generates the real code.
export const previewCode = ({ deviceType, manufacturer, model, variant }) =>
    [deviceType, manufacturer, model, variant]
        .filter(Boolean)
        .map(seg => String(seg).toUpperCase().replace(/[^A-Z0-9]+/g, '-').replace(/^-|-$/g, ''))
        .filter(Boolean)
        .join('_');

export const personName = (p) => (p && typeof p === 'object' ? [p.name, p.lastName].filter(Boolean).join(' ') : '');

export const formatDate = (d) =>
    d ? new Date(d).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' }) : '';

export const formatSize = (bytes) => {
    if (!bytes && bytes !== 0) return '';
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1048576) return `${Math.round(bytes / 1024)} KB`;
    return `${(bytes / 1048576).toFixed(1)} MB`;
};

// Starts each signed URL as a download, one after another. The API sets
// Content-Disposition: attachment, so the page doesn't navigate away.
// Browsers may block all but the first; callers show the links as a fallback.
export const startDownloads = (files, gapMs = 600) =>
    files.reduce((p, f) => p.then(() => new Promise(resolve => {
        const a = document.createElement('a');
        a.href = f.url;
        a.download = f.fileName;
        a.rel = 'noopener';
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        a.remove();
        setTimeout(resolve, gapMs);
    })), Promise.resolve());
